module.exports = __webpack_public_path__ + "img/96d061c.png";